export function calculateOverflow<T>(items: Array<T>, limit: number): [Array<T>, number] {
  if (items.length <= limit) {
    return [items, 0];
  }

  return [items.slice(0, limit - 1), items.length - limit + 1];
}
